import isIFrame from "./isIFrame";

export type WidgetEvent = "slot_selected" | "booking_completed";

export const WIDGET_MESSAGE_SOURCE = "gotcourts";

export interface WidgetMessage {
	source: typeof WIDGET_MESSAGE_SOURCE;
	event: WidgetEvent;
	payload: Record<string, unknown>;
}

function getSearchParams(): URLSearchParams {
	return new URLSearchParams(window?.location?.search || "");
}

export function isWidgetMode(): boolean {
	return getSearchParams().get("widgetMode") === "true";
}

/**
 * The embedding page's origin, passed by widget.js as `parentOrigin`.
 * Falls back to "*" when the param is missing (older cached widget.js) or not a valid origin.
 */
export function getParentOrigin(): string {
	const parentOrigin = getSearchParams().get("parentOrigin");

	if (!parentOrigin) return "*";

	try {
		const { origin } = new URL(parentOrigin);
		return origin && origin !== "null" ? origin : "*";
	} catch (e) {
		return "*";
	}
}

/**
 * Notify the page embedding the widget iframe about an event.
 * No-op outside widget mode or outside an iframe. Never throws.
 */
export function postWidgetMessage(event: WidgetEvent, payload: Record<string, unknown>): void {
	try {
		if (!isWidgetMode() || !isIFrame()) return;

		const message: WidgetMessage = { source: WIDGET_MESSAGE_SOURCE, event, payload };
		window.parent.postMessage(message, getParentOrigin());
	} catch (e) {
		console.warn("could not post widget message", e);
	}
}
